import { render, staticRenderFns } from "./IndexHeaderComponent.vue?vue&type=template&id=27f98788"
import script from "./IndexHeaderComponent.vue?vue&type=script&lang=js"
export * from "./IndexHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./IndexHeaderComponent.vue?vue&type=style&index=0&id=27f98788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports